export class UploadFileMasterDataColumn {

    public name: string;
    public type: MasterImportColumnType;
    public sample: any;

    static fromDto(data: any) {
      if (!data) {
        return null;
      }

      const column = new UploadFileMasterDataColumn();

      column.name   = data.name;
      column.type   = data.type;
      column.sample = data.sample;

      return column;
    }
  }

  export enum MasterImportColumnType {
    STRING    = 'STRING',
    NUMBER    = 'NUMBER',
    ENUM      = 'ENUM'
  }
